import type { AppThunk } from '@/app/store';
import {
  loadPersistedSession,
  selectSession,
  sessionRestored,
  signedOut,
  subscribeToSessionChangesInOtherTabs,
} from '@/shared/session';

/** Restores a persisted, unexpired session. Dispatch once before the first render. */
export const restoreSession = (): AppThunk => (dispatch) => {
  const session = loadPersistedSession();
  if (session) dispatch(sessionRestored(session));
};

/**
 * Mirrors sign-in/sign-out performed in other tabs that share the "remember me" session.
 * A tab with its own per-tab session is left alone. Returns an unsubscribe function.
 */
export const syncSessionAcrossTabs = (): AppThunk<() => void> => (dispatch, getState) =>
  subscribeToSessionChangesInOtherTabs(({ session, previousAccessToken }) => {
    const current = selectSession(getState());
    const sharesStoredSession = current === null || current.accessToken === previousAccessToken;
    if (!sharesStoredSession) return;

    if (session) {
      dispatch(sessionRestored(session));
    } else if (current) {
      dispatch(signedOut());
    }
  });
